var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashHFinanceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1172 5.41357L9.08735 8.45833C8.68083 9.06811 7.76722 9.01123 7.43948 8.35574V8.35574C7.11173 7.70025 6.19813 7.64337 5.79161 8.25315L3.76177 11.2979",
    stroke: "#05073C",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.81958,
    y: 1,
    width: 13.2398,
    height: 13.2398,
    rx: 1,
    stroke: "#05073C",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashHFinanceIcon);
export default __webpack_public_path__ + "static/media/dash-h-finance-icon.76ffea7cb40fee6d2e75576f213b6fa3.svg";
export { ForwardRef as ReactComponent };